// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
// import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { SvgIcon, SvgIconProps } from '@mui/material';

type DataManagementIconProps = SvgIconProps

const DataManagementIcon: React.FC<DataManagementIconProps> = (props) => {
  return (
    <SvgIcon  width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <g opacity="0.34">
        <path 
          d="M5.00049 1L1.00049 5H4.00049V9H6.00049V5H9.00049L5.00049 1ZM12.0005 11V7H10.0005V11H7.00049L11.0005 15L15.0005 11H12.0005Z"
          fill="black" 
        />
      </g>
    </SvgIcon>
  );
};

export default DataManagementIcon;
